import styled from "styled-components";
export const Caption = styled.h1`
  text-align: center;
  padding: 15px;
  background-color: lightblue;
  margin-bottom: 30px;
`;
